var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{},[_vm._v("\n  第一个录音：\n  "),_c('Sound',{ref:"sound",attrs:{"str":"sound"}}),_vm._v("\n\n  第二个录音：\n  "),_c('Sound',{ref:"soundtwo",attrs:{"str":"soundtwo"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }